import { Store } from "lucide-react";
import { useStore } from "@/context/StoreContext";

export default function ActiveStoreBanner() {
  const { active, multiTenant } = useStore();
  if (!multiTenant || !active) return null;
  return (
    <div
      data-testid="active-store-banner"
      className="md:sticky md:top-0 z-20 bg-primary text-primary-foreground px-4 md:px-10 py-2.5 flex items-center gap-3"
    >
      <Store className="w-4 h-4 shrink-0" strokeWidth={1.5} />
      <span className="text-[10px] uppercase tracking-[0.22em] opacity-75 shrink-0">Active store</span>
      <span className="font-display text-lg leading-none truncate" data-testid="active-store-name">
        {active.store_name}
      </span>
      <span className="text-xs opacity-70 truncate hidden sm:inline">{active.tenant_name}</span>
      <span className="ml-auto text-[11px] opacity-75 hidden lg:inline">
        Stock, prices, sales & checkout on this screen are for {active.store_name} only
      </span>
    </div>
  );
}
